import React from 'react';
import fr from 'facet-rest';
import {
  FDEmphasisSurface, FDIcon, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import {
  FilingBox,
  filingBoxMetaOverrideSet,
} from 'Views/Page/Content/Templates/TaxDashboardPage/Components/MainContent/FilingBox';

export const HeroLayout = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const theme = useTheme();
  return (
    <FDEmphasisSurface padding={3} flex={1}>
      <FDStack direction="row" justifyContent="center" paddingY={isMobile ? 0 : 8}>
        <FDStack direction="column" paddingY={1} spacing={3} alignItems="center" maxWidth={theme.dimensions.lg}>
          <FDIcon icon="fac" />
          <MetaControlField attr="title" />
          <MetaControlField attr="body" />
          <MetaControlField attr="insight" />
          <FDStack direction={'row'} wrap spacing={2}>
            {resource.attr('filings') && (
              <MetaCollectionRenderer
                collection={resource.attr('filings')}
                layout={FilingBox}
                metaOverrideSet={filingBoxMetaOverrideSet}
              />
            )}
          </FDStack>
          <PrimaryActionButtonRel relationship={resource.relationship(fr.relationships.main.name)} />
        </FDStack>
      </FDStack>
    </FDEmphasisSurface>
  );
};
